<template>
    <v-card>
        <v-card-title class="subheading">
            <strong> Expression Builder </strong>
            <v-spacer/>
            <v-btn @click="applyExpression"  small class="teal white--text">Apply</v-btn>
            &nbsp;
            <v-icon @click="applyExpression" small class="grey---text"> fas fa-times</v-icon>
           
        </v-card-title>
        <hr>
        <v-card-text>    
            <v-layout row wrap>
                <v-flex xs8> 
                <v-textarea 
                id="expression"
                 v-model="expression"
                 rows=5
                 />
                 <br/>
                 <v-btn @click="selectColumn('SUM(<expr>)')" small class="grey black--text" >SUM</v-btn>
                 <v-btn @click="selectColumn('AVG(<expr>)')" small class="grey black--text" >AVG</v-btn>
                 <v-btn @click="selectColumn('MAX(<expr>)')" small class="grey black--text" >MAX</v-btn>
                 <v-btn @click="selectColumn('MIN(<expr>)')" small class="grey black--text" >MIN</v-btn>
                 <v-btn @click="selectColumn('+')" small class="grey black--text" >+</v-btn>
                  <br/>
                 <v-btn @click="seletColumn('1')" small class="grey black--text" >1</v-btn>
                 <v-btn @click="seletColumn('2')" small class="grey black--text" >2</v-btn>
                 <v-btn @click="seletColumn('3')"  small class="grey black--text" >3</v-btn>
                 <v-btn @click="seletColumn('4')"  small class="grey black--text" >4</v-btn>
                 <v-btn @click="seletColumn('-')"  small class="grey black--text" >-</v-btn>
                
                 <br/>
                 <v-btn  @click="selectColumn('5')" small class="grey black--text" >5</v-btn>
                 <v-btn  @click="selectColumn('6')" small class="grey black--text" >6</v-btn>
                 <v-btn  @click="selectColumn('7')" small class="grey black--text" >7</v-btn>
                 <v-btn  @click="selectColumn('8')" small class="grey black--text" >8</v-btn>
                 <v-btn  @click="selectColumn('*')" small class="grey black--text" >*</v-btn>
                 
                
                 <br/>
                 <v-btn  @click="selectColumn('9')" small class="grey black--text" >9</v-btn>
                 <v-btn  @click="selectColumn('0')" small class="grey black--text" >0</v-btn>
                 <v-btn  @click="selectColumn('(')"  small class="grey black--text" >(</v-btn>
                 <v-btn  @click="selectColumn(')')"  small class="grey black--text" >)</v-btn>
                <v-btn   @click="selectColumn('/')" small class="grey black--text" >/</v-btn>
                 <br/>
                 <v-btn @click="selectColumn('%')" small class="grey black--text" >%</v-btn>
                 <v-btn @click="selectColumn('')"  small class="grey black--text" >CLR</v-btn>
                
                </v-flex>
                <v-flex xs4>
                    <v-card>
                        <v-card-title class="body-2 teal white--text"><strong>Choose Columns</strong></v-card-title>
                        <v-card-text>
                            <v-layout row wrap style="height:300px;overflow:scroll">
                      <template v-for="reportColumn in JSON.parse(columns)">
                            <v-flex xs12 class="body-1 " style="padding:5px;">
                               <span  style="cursor:pointer" @click="selectColumn(reportColumn.key)"> {{reportColumn.label}}</span>
                            </v-flex>
                       </template>
                       </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
               
            </v-layout>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    
    props: [
        "columns"
    ],
    data() {
        return {
            "expression":"",
            "functions":[
                "sum",'if','case','max','min','count','avg'
            ]
        }
    },
    created:function() {

    },
    mounted:function() {

    },
    methods: {
        applyExpression() {
            this.$emit('applyExpression',this.expression)
        },
        selectColumn($key) {
            //this.expression = this.expression+ $key
            var txtarea = document.getElementById("expression");
            var start = txtarea.selectionStart;
            var finish = txtarea.selectionEnd;
            alert(start)
            var allText = txtarea.value;
            // obtain the selected text
            var sel = allText.substring(start, finish);
            //append te text;
            var newText=allText.substring(0, start)+" "+$key+" "+allText.substring(finish, allText.length);

            console.log(newText);

            //txtarea.value=newText;
            this.expression = newText
        }
    }
}
</script>